<template>
   <div>
        <button type="button" class="asset-buttton primary" @click="viewAsset">
            {{$t('text.clickButtons.viewAsset')}}
        </button>
   </div>
</template>

<script>
import configObject from "@/config";
import Jquery from "jquery";
let $ = Jquery;

export default {
    data() {
        return {
            data: {},
        };
    },
    methods: {
        viewAsset: function() {
            this.$eventHub.$emit("setAssetModalValue", this.data)
        }   
    }
};
</script>